import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dk-home"
}

import {
  ref,
  computed,
  onMounted,
  onServerPrefetch,
  ComponentPublicInstance,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useActiveMeta, useMeta } from 'vue-meta';
import { useMq } from 'vue3-mq';

import DKSearch from '@/components/search/DKSearch.vue';
import GenericPageRenderer from '@/components/GenericPageRenderer.vue';
import { DKValuePromise } from '@dormakaba/dormakaba-components';
import { isDesktop as $isDesktop } from '@dormakaba/dormakaba-components';

import { DKMetaInfo } from '@/models/DKMetaInfo';
import { DKHomePage } from '@/models/DKHomePage';
import { DKValuePromise as DKValuePromiseType } from '@dormakaba/dormakaba-components/dist/types/lib/models/DKValuePromise';
import { DKHomePageContentFragmentsItem } from '@/models/DKHomePageContentFragmentsItem';

import { trackView } from '@/helpers/google';
import { generateMetaInfo } from '@/helpers/metainfo';
import { getLanguageFromLocale } from '@/helpers/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const { locale } = useI18n();
const metaInfoRef = useMeta({ ...useActiveMeta() });
const mq = useMq();

const valuePromise = ref<ComponentPublicInstance<HTMLElement> | undefined>();

const isDesktop = computed<boolean>(() => $isDesktop(mq));
const homePage = computed<DKHomePage>(() => store.getters['content/homePage']);
const homePageId = computed<string | null>(() =>
  store.getters['navigation/pageIdBySlug']('')
);
const valuePromises = computed<DKValuePromiseType[]>(
  () => store.getters['content/valuePromises']
);
const searchSuggestions = computed<string[]>(
  () => store.getters['content/homeSearchTerms']
);
const homePageFragments = computed<DKHomePageContentFragmentsItem[]>(
  () => homePage.value.contentFragments || []
);
const metaInfo = computed<DKMetaInfo>(() => ({
  meta: metaInfoRef.meta,
  page: homePage.value,
  locale: locale.value,
  $route: route,
}));

onServerPrefetch(async () => {
  return Promise.all([
    store.dispatch('content/fetchHomePage', {
      id: homePageId.value,
      locale: locale.value,
      $route: route,
      $router: router,
    }),
  ]).then(() => generateMetaInfo(metaInfo.value));
});

onMounted(async () => {
  await store.dispatch('content/fetchHomePage', {
    id: homePageId.value,
    locale: locale.value,
    $route: route,
    $router: router,
  });

  const meta = generateMetaInfo(metaInfo.value);

  trackView('home_page', meta.title);

  if (valuePromise.value) {
    store.commit(
      'navigation/setNavbarTransparentElement',
      valuePromise.value.$el
    );
  }
});

const onSearch = (searchTerm: string) => {
  router.push({
    name: 'search-page',
    params: { locale: getLanguageFromLocale(locale.value) },
    query: { q: searchTerm },
  });
};

return (_ctx: any,_cache: any) => {
  return (homePage.value && homePageId.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(DKValuePromise), {
          ref_key: "valuePromise",
          ref: valuePromise,
          items: valuePromises.value,
          label: _ctx.$t('value_promise.link.label')
        }, null, 8, ["items", "label"]),
        _createElementVNode("section", null, [
          _createVNode(DKSearch, {
            id: "home-search",
            label: _ctx.$t('home.search.label'),
            searchSuggestions: searchSuggestions.value,
            placeholder: 
          isDesktop.value ? _ctx.$t('search.input.placeholder') : _ctx.$t('search.input.label')
        ,
            onSearch: onSearch,
            onClickSearchSuggestion: onSearch
          }, null, 8, ["label", "searchSuggestions", "placeholder"])
        ]),
        _createVNode(GenericPageRenderer, { fragments: homePageFragments.value }, null, 8, ["fragments"])
      ]))
    : _createCommentVNode("", true)
}
}

})